<template>
    <v-card class="mx-3" min-height="80%">
        <v-tabs color="#FA1E95" grow v-model="tab" @change="refreshTable()">
            <v-tab v-for="(item, i) in tabs" :key="i">
                {{ item }}
            </v-tab>

            <v-tab-item>
                <support-form />
            </v-tab-item>

            <v-tab-item>
                <filter-form />
                <support-table />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import SupportForm from './components/SupportForm'
import SupportTable from './components/SupportTable'
import FilterForm from './components/FilterForm'
export default {
    components: {
        SupportForm,
        SupportTable,
        FilterForm
    },
    data() {
        return {
            tabs: ["Gửi hỗ trợ", "Danh sách"],
            tab: ""
        }
    },
    created(){
       if (this.$route.query?.tab == "listRequest" ){
        this.tab = 1
         }
    },
    methods: {
      refreshTable() {
            if (this.tab == 1 ){
                Bus.$emit('fetch-table-while-change-tab5')
            }
        }
    }
}
</script>

<style scoped>
/deep/.v-input__prepend-outer {
  transform: rotate(45deg);
}
</style>